/**
 * These styles kinda look like a mess due to needing multiple media queries!
 * Need highly specific-stuff to deal with different form positioning at different sizes
 * Ignore the lazy z-indexing plz...
 */

import styled from 'styled-components/macro';

// import theme helpers
import { getBreakpoint, getColor, getFontWeight } from '../../../util/theme';

const determineDynamicProperties = (formExpanded, formScrolled, properties) => {
  if ((formExpanded && !formScrolled) || (formExpanded && formScrolled)) {
    return properties[0];
  }

  if (!formExpanded && formScrolled) {
    return properties[1];
  }

  return properties[0];
};

const FormWrapper = styled.div`
  background-color: ${props =>
    determineDynamicProperties(props.formExpanded, props.formScrolled, [
      getColor('primaryBlue'),
      getColor('accentRed'),
    ])};

  padding: 15px;

  position: ${props => (props.formScrolled ? 'fixed' : 'relative')};
  top: ${props => (props.formScrolled ? '75px' : null)};
  right: 0;
  z-index: 9998;

  height: ${props =>
    props.successful
      ? '110px'
      : props.formExpanded && props.formScrolled
      ? '575px'
      : determineDynamicProperties(props.formExpanded, props.formScrolled, [
          '620px',
          '75px',
        ])};
  width: 100%;

  overflow: ${props => (props.formExpanded ? 'auto' : 'hidden')};

  transition: height 0.25s linear, background-color 0.25s linear;

  @media (min-width: ${getBreakpoint('sm')}) {
    height: ${props =>
      props.successful
        ? '90px'
        : determineDynamicProperties(props.formExpanded, props.formScrolled, [
            '550px',
            '50px',
          ])};
  }

  @media (min-width: ${getBreakpoint('md')}) {
    height: ${props =>
      props.successful
        ? '90px'
        : determineDynamicProperties(props.formExpanded, props.formScrolled, [
            '500px',
            '50px',
          ])};
  }

  @media (min-width: ${getBreakpoint('lg')}) {
    top: ${props => (props.formScrolled ? '100px' : null)};
  }

  @media (min-width: ${getBreakpoint('xl')}) {
    position: ${props => (props.formScrolled ? 'fixed' : 'absolute')};
    top: ${props => (props.formScrolled ? '100px' : '125px')};
    right: ${props => `${(props.windowWidth - 1084) / 2}px`};

    padding: 25px;

    height: ${props =>
      props.successful
        ? '150px'
        : determineDynamicProperties(props.formExpanded, props.formScrolled, [
            '620px',
            '105px',
          ])};
    width: 425px;

    overflow: hidden;
  }

  h2,
  h3 {
    color: ${getColor('white')};
  }

  h2 {
    display: flex;
    justify-content: space-between;

    font-size: 1.8rem;

    margin: 0 0 15px 0;

    @media (min-width: ${getBreakpoint('xl')}) {
      font-size: 2.4rem;
    }

    br {
      display: inline-block;

      @media (min-width: ${getBreakpoint('sm')}) {
        display: none;
      }
    }

    span {
      align-self: flex-end;

      cursor: pointer;

      transform: ${props =>
        props.formExpanded ? 'rotate(180deg)' : 'rotate(0deg)'};

      transition: all 0.25s linear;

      &:hover {
        svg {
          polygon {
            fill: ${getColor('accentGreen')};
          }
        }
      }

      svg {
        polygon {
          fill: ${getColor('white')};
        }
      }
    }
  }

  h3 {
    font-size: 1.6rem;
    font-weight: ${getFontWeight('medium')};

    @media (min-width: ${getBreakpoint('lg')}) {
      font-size: 2rem;
    }
  }

  .disclaimer {
    color: ${getColor('white')};
    font-size: 0.8rem;
    line-height: 1.5;
  }
`;

export default FormWrapper;
